import React from 'react'
import BootstrapNav from 'react-bootstrap/Nav'
import styled from 'styled-components'
import Icon from './NavIcon'
import StyledIcon, { isIconOption } from '../Icon'

interface DropdownToggleProps {
    text: string
    icon?: string
    onClick: () => void
    direction?: 'right'
}

const S = {
    DropdownToggle: styled(BootstrapNav.Item)`
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 180px;
        width: 100%;
        height: 100%;
        font-size: 14px;
    `
}

// forwardRef is recommended by bootstrap here.
// eslint-disable-next-line react/display-name,@typescript-eslint/no-unused-vars
const DropdownToggle = React.forwardRef(({
    text, onClick, icon, direction,
}: DropdownToggleProps, ref) => (
    <S.DropdownToggle onClick={onClick} className="nav-link" ref={ref}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {icon && isIconOption(icon)
                && <Icon icon={icon} size={18} />}
            <span>{ text }</span>
        </div>
        <StyledIcon icon="chevronDown" size={18} style={direction === 'right' && { transform: 'rotate(-90deg)' }} />
    </S.DropdownToggle>
))

export default DropdownToggle
